import { render } from "./edit-form.vue?vue&type=template&id=09956a59&scoped=true"
import script from "./edit-form.vue?vue&type=script&lang=js"
export * from "./edit-form.vue?vue&type=script&lang=js"

import "./edit-form.vue?vue&type=style&index=0&id=09956a59&scoped=true&lang=css"
import "./edit-form.vue?vue&type=style&index=1&id=09956a59&lang=css"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09956a59"]])

export default __exports__